import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Archive.svg",
  "use": "Archive.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Archive.svg\"><path d=\"M52.01,20.0208h-40a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h40a2,2,0,0,1,2,2v4A2,2,0,0,1,52.01,20.0208Zm-2,2a1,1,0,0,1,1,1v26a3,3,0,0,1-3,3h-32a3,3,0,0,1-3-3v-26a1,1,0,0,1,1-1Zm-24,10h12a2,2,0,0,0,0-4h-12a2,2,0,0,0,0,4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol